const findElement = (array, value) => {
  for (let i = 0; i < array.length; i++) {
    const element = array[i][0]
    if (element === value) {
      return true
    }
  }
  return false
}

const sortMultidimensional = (array, index, isUserArray = false) => {
  return array.sort((a, b) => {
    let firstElement = a[index]
    let secondElement = b[index]
    if (isUserArray) {
      firstElement = a.data[index]
      secondElement = b.data[index]
    }

    if (firstElement === null && secondElement !== null) {
      return -1
    }
    if (firstElement !== null && secondElement === null) {
      return 1
    }
    if (firstElement === null && secondElement === null) {
      return 0
    }
    if (firstElement < secondElement) {
      return -1
    }
    if (firstElement > secondElement) {
      return 1
    }
    if (firstElement.toLowerCase() < secondElement.toLowerCase()) {
      return -1
    }
    if (firstElement.toLowerCase() > secondElement.toLowerCase()) {
      return 1
    }
    return 0
  })
}

const sortMultidimensionalInverse = (array, index) => {
  return array.sort((a, b) => {
    let firstElement = a[index]
    let secondElement = b[index]

    if (firstElement === null && secondElement !== null) {
      return 1
    }
    if (firstElement !== null && secondElement === null) {
      return -1
    }
    if (firstElement === null && secondElement === null) {
      return 0
    }
    if (firstElement < secondElement) {
      return 1
    }
    if (firstElement > secondElement) {
      return -1
    }
    if (firstElement.toLowerCase() < secondElement.toLowerCase()) {
      return 1
    }
    if (firstElement.toLowerCase() > secondElement.toLowerCase()) {
      return -1
    }
    return 0
  })
}

export default { findElement, sortMultidimensional, sortMultidimensionalInverse }



// WEBPACK FOOTER //
// ./src/lib/Arrays.js